<form
  class="tab d-block mb-3"
  id="form"
  action="#"
  #f="ngForm"
  (ngSubmit)="form(f)"
  autocomplete="off"
>
  <section class="container mt-5">
    <h4 class="text-red text-center font-weight-bold mb-0">
      Subir un Proyecto
    </h4>

    <div class="row">
      <div class="col-lg-8">
        <label class="font-weight-bold mb-0" for="title"
          >Título del proyecto</label
        >
        <div class="input-group mb-3">
          <input
            type="text"
            name="title"
            id="title"
            class="col px-2"
            [class]="
              f.submitted && f.controls['title']?.errors ? 'border-danger' : ''
            "
            placeholder="Titulo del proyecto"
            [(ngModel)]="title"
            required
          />
          <span
            *ngIf="f.submitted && f.controls['title']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>
      </div>
      <div class="col-lg-4">
        <label class="mb-0 font-weight-bold" for="logo">
          Subir logo del proyecto
        </label>
        <div class="input-group mb-3">
          <input
            type="file"
            accept="image/*"
            name="logo"
            id="logo"
            class="col pt-1"
            [class]="
              f.submitted && f.controls['logo']?.errors ? 'border-danger' : ''
            "
            placeholder="Logo del proyecto"
            (change)="fileLogo($event)"
            required
          />
          <span
            *ngIf="f.submitted && f.controls['logo']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>
      </div>
    </div>
  </section>

  <section class="container pb-2">
    <h4 class="text-color-black text-center text-semibold mb-0">
      Administra tus fotos
    </h4>
    <div class="photo">
      <div class="row mb-2">
        <div class="col-md-12 pt-3" *ngIf="croppedImages?.length > 0">
          <div class="row mx-0">
            <ng-container *ngFor="let cp of croppedImages; index as i">
              <div
                class="col-6 col-md-3 col-xl-2 mb-2"
                *ngIf="cp.data == 'files'"
              >
                <div class="photo w-100 container-hover">
                  <img
                    src="{{
                      cp.type == 'image' ? cp.cropped : getMimeVideo(cp)
                    }}"
                    class="img-selected image-hover"
                    style="min-height: 154px; max-height: 100px"
                  />
                  <span
                    *ngIf="i == 0"
                    style="
                      position: absolute;
                      top: 0;
                      background: #ffffffcc;
                      line-height: 1;
                      font-weight: 700;
                      font-size: 0.75em;
                      right: 0;
                      left: 0;
                      text-align: center;
                      padding: 0.25em 0;
                    "
                    >Esta es tu imagen destacada</span
                  >
                  <div class="row mx-0 mt-2 justify-content-center">
                    <div
                      data-toggle="modal"
                      data-target="#imagesModal"
                      data-backdrop="static"
                      data-keyboard="false"
                      class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                      *ngIf="cp.event && cp.type == 'image'"
                      (click)="editCroppedImage(cp, i)"
                    >
                      <a
                        class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                      >
                        <i class="fas fa-edit"></i>
                      </a>
                    </div>
                    <div
                      class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                      *ngIf="!edit"
                      (click)="croppedImages.splice(i, 1)"
                    >
                      <a
                        class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                      >
                        <i class="fas fa-trash"></i>
                      </a>
                    </div>
                    <div
                      class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                      *ngIf="!edit && i != 0"
                      (click)="changePosition(i)"
                    >
                      <a
                        class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                      >
                        <i class="fas fa-star"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="row justify-content-center col-lg-12">
          <div class="col-lg-auto">
            <label
              for="files"
              class="d-block btn-yellow p-sm-90 text-center mx-auto p-2 mt-2 mb-0 cursor-pointer"
              style="width: 150px"
              >Subir foto</label
            >
            <input
              type="file"
              accept="image/*"
              style="display: none"
              multiple
              id="files"
              (change)="fileChangeEvent($event, 'files')"
            />
          </div>
        </div>
        <span class="col-12 text-center mt-1 text-info"
          >Para cambiar tu imagen destacada, pasa el cursor sobre la imagen
          deseada y haz clic en el ícono
          <a class="bg-yellow text-white p-1">
            <i class="fas fa-star"></i>
          </a>
        </span>
      </div>
    </div>
  </section>
  <section class="container py-2 border-bottom">
    <h4 class="text-red text-center font-weight-bold">Ubicación de Proyecto</h4>

    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <input
            type="text"
            name="address"
            id="address"
            placeholder="Introduce una dirección"
            ngModel
            class="px-2 w-100"
            [class]="
              f.submitted && f.controls['address']?.errors
                ? 'border-danger'
                : ''
            "
            autocorrect="off"
            autocapitalize="off"
            spellcheck="off"
            #search
            required
          />

          <span
            *ngIf="f.submitted && f.controls['address']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group">
          <input
            type="text"
            name="city"
            id="city"
            placeholder="Ciudad"
            class="px-2 w-100"
            [class]="
              f.submitted && f.controls['city']?.errors ? 'border-danger' : ''
            "
            [(ngModel)]="city"
            required
          />
          <span
            *ngIf="f.submitted && f.controls['city']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group">
          <input
            type="text"
            name="zone"
            id="zone"
            placeholder="Zona residencial o barrio"
            [class]="
              f.submitted && f.controls['zone']?.errors ? 'border-danger' : ''
            "
            class="px-2 w-100"
            [(ngModel)]="zone"
            required
          />
          <span
            *ngIf="f.submitted && f.controls['zone']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <input
            type="text"
            name="complement"
            id="complement"
            placeholder="Complemento de la dirección"
            [class]="
              f.submitted && f.controls['complement']?.errors
                ? 'border-danger'
                : ''
            "
            class="px-2 w-100"
            [(ngModel)]="complement"
            required
          />
          <span
            *ngIf="f.submitted && f.controls['complement']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>
      </div>
    </div>

    <div class="text-blue pb-2 lh-1 text-center text-lg-left">
      Puedes mover el marcador en la ubicación correcta de tu proyecto.
    </div>

    <div class="mx-auto contiene-map">
      <agm-map
        [latitude]="lat"
        [longitude]="lng"
        [zoom]="zoom"
        [mapTypeId]="'hybrid'"
        [disableDefaultUI]="true"
      >
        <agm-marker
          [latitude]="lat"
          [longitude]="lng"
          [markerDraggable]="true"
          (dragEnd)="markerDragEnd($event)"
        ></agm-marker>
      </agm-map>
    </div>
    <div class="my-2">
      <div class="row align-items-center small">
        <div class="col-lg-4 text-blue text-center text-lg-left">
          <b> Debes confirmar la ubicación del proyecto </b>
        </div>
        <div class="col-lg-5 text-center text-lg-left">
          Has ubicado el proyecto en:
          <br class="d-md-none" />
          {{ address || "(Ingresa una dirección en la parte superior)" }}
        </div>
        <div class="col-lg-3">
          <div
            class="d-flex justify-content-center align-items-center mt-3 mt-lg-0"
          >
            <input
              type="checkbox"
              id="confirm-address"
              name="confirm-address"
              required
            />
            <label for="confirm-address" class="pb-0 mb-0"> </label>
            <label for="confirm-address" class="ml-2 pb-0 mb-0">
              Confirmar ubicación del proyecto
            </label>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="container py-2 border-bottom">
    <h4 class="text-red text-center font-weight-bold">
      Información del Proyecto
    </h4>

    <div class="row">
      <div class="col-lg-6">
        <textarea
          name="description"
          id="description"
          placeholder="Descripción del proyecto"
          [(ngModel)]="description"
          rows="5"
          class="w-100 px-3 form-control"
          maxlength="2000"
        ></textarea>
        <h6 class="number text-right">
          <span id="charNum">{{ description.length }}</span
          >/2000
        </h6>
      </div>
      <div class="col-lg-6">
        <div class="input-group input-currency mb-3">
          <div class="input-group-prepend">
            <select
              name="currency"
              id="currency"
              class="custom-select"
              [(ngModel)]="currency"
              required
              [class]="
                f.submitted && f.controls['currency']?.errors
                  ? 'border-danger'
                  : ''
              "
              (change)="getSelectedValue($event)"
            >
              <option
                [value]="currency.iso"
                [title]="currency.name"
                *ngFor="let currency of currencies"
              >
                {{ currency.iso }}
              </option>
              <i class="fas fa-chevron-down"></i>
            </select>
          </div>
          <input
            type="text"
            name="currency_value"
            id="currency_value"
            class="col px-2"
            [class]="
              f.submitted && f.controls['currency_value']?.errors
                ? 'border-danger'
                : ''
            "
            [placeholder]="
              'Valor (desde) del inmueble (' + currencyPlaceholder + ') *'
            "
            [(ngModel)]="value"
            onkeyup="var value = parseInt(this.value.replace(/\D/g,''), 10);value = isNaN(value) ? '' : value;this.value = value.toLocaleString();"
            required
          />
          <span
            *ngIf="f.submitted && f.controls['currency_value']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>

        <input
          ngModel
          type="text"
          placeholder="Telefono"
          inputmode="numeric"
          name="telephone"
          id="telephone"
          [class]="
            f.submitted && f.controls['telephone']?.errors
              ? 'border-danger'
              : ''
          "
          class="px-3 w-100 mb-3"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
          required
          (input)="errorArea = false"
        />
        <input
          ngModel
          type="text"
          placeholder="WhatsApp"
          inputmode="numeric"
          name="whatsapp"
          id="whatsapp"
          [class]="
            f.submitted && f.controls['whatsapp']?.errors ? 'border-danger' : ''
          "
          class="px-3 w-100 mb-3"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
          required
          (input)="errorArea = false"
        />
        <input
          ngModel
          type="email"
          placeholder="Email"
          inputmode="numeric"
          name="email"
          id="email"
          [class]="
            f.submitted && f.controls['email']?.errors ? 'border-danger' : ''
          "
          class="px-3 w-100 mb-3"
          required
          (input)="errorArea = false"
        />
        <input
          ngModel
          type="text"
          placeholder="website"
          inputmode="numeric"
          name="website"
          id="website"
          [class]="
            f.submitted && f.controls['website']?.errors ? 'border-danger' : ''
          "
          class="px-3 w-100 mb-3"
          required
          (input)="errorArea = false"
        />
      </div>
    </div>

    <div class="row mt-3 mt-xl-2 mb-lg-2">
      <div class="col-md-4 mb-3 mb-xl-0">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 pr-0">
            <p class="mb-0">N° unidades en venta:</p>
          </div>
          <div class="col-6">
            <div
              class="input-group border text-center justify-content-between rounded-20"
            >
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  [disabled]="quantity == 0"
                  (click)="quantity = quantity - 1"
                >
                  <i class="fas fa-minus small"></i>
                </button>
              </span>
              <input
                type="text"
                inputmode="numeric"
                name="quantity"
                id="quantity"
                [(ngModel)]="quantity"
                value="{{ quantity }}"
                class="w-25 text-center m-0 border-0"
                required
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  (click)="quantity = quantity + 1"
                >
                  <i class="fas fa-plus small"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-3 mb-xl-0">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 pr-0">
            <p class="mb-0 lh-1">Fecha estimada de entrega:</p>
          </div>
          <div class="col-6">
            <input
              type="date"
              [(ngModel)]="stimated_date"
              name="stimated_date"
              id="stimated_date"
              class="form-control w-100"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-3 mb-xl-0">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 pr-0">
            <p class="mb-0 lh-1">Tipo de subsidio:</p>
          </div>
          <div class="col-6">
            <select
              class="form-control w-100"
              [(ngModel)]="vis"
              name="vis"
              id="vis"
            >
              <option value="vip-vis">VIP/VIS</option>
              <option value="no-vis">NO VIS</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="container py-2 border-bottom">
    <h4 class="text-red text-center font-weight-bold">Zonas Comunes</h4>
    <div class="row">
      <div class="col-md-7">
        <div class="photo h-100 place-content-center mb-2">
          <div class="row mb-2">
            <div class="col-md-12 pt-3" *ngIf="croppedImages?.length > 0">
              <div class="row mx-0">
                <ng-container *ngFor="let cp of croppedImages; index as i">
                  <div
                    class="col-6 col-md-3 col-xl-4 mb-2"
                    *ngIf="cp.data == 'zone_files'"
                  >
                    <div class="photo w-100 container-hover">
                      <img
                        src="{{
                          cp.type == 'image' ? cp.cropped : getMimeVideo(cp)
                        }}"
                        class="img-selected image-hover"
                        style="min-height: 154px; max-height: 100px"
                      />
                      <span
                        *ngIf="i == 0"
                        style="
                          position: absolute;
                          top: 0;
                          background: #ffffffcc;
                          line-height: 1;
                          font-weight: 700;
                          font-size: 0.75em;
                          right: 0;
                          left: 0;
                          text-align: center;
                          padding: 0.25em 0;
                        "
                        >Esta es tu imagen destacada</span
                      >
                      <div class="row mx-0 mt-2 justify-content-center">
                        <!-- <div
                          data-toggle="modal"
                          data-target="#imagesModal"
                          data-backdrop="static"
                          data-keyboard="false"
                          class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                          *ngIf="cp.event && cp.type == 'image'"
                          (click)="editCroppedImage(cp, i)"
                        >
                          <a
                            class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                          >
                            <i class="fas fa-edit"></i>
                          </a>
                        </div> -->
                        <div
                          class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                          *ngIf="!edit"
                          (click)="croppedImages.splice(i, 1)"
                        >
                          <a
                            class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                          >
                            <i class="fas fa-trash"></i>
                          </a>
                        </div>
                        <div
                          class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                          *ngIf="!edit && i != 0"
                          (click)="changePosition(i)"
                        >
                          <a
                            class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                          >
                            <i class="fas fa-star"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="row justify-content-center col-lg-12">
              <div class="col-lg-auto">
                <label
                  for="zone_files"
                  class="d-block btn-yellow p-sm-90 text-center mx-auto p-2 mt-2 mb-0 cursor-pointer"
                  style="width: 150px"
                  >Subir foto</label
                >
                <input
                  type="file"
                  accept="image/*"
                  style="display: none"
                  multiple
                  id="zone_files"
                  (change)="fileChangeEvent($event, 'zone_files')"
                />
              </div>
            </div>
            <span class="col-12 text-center mt-1 text-info small"
              >Para cambiar tu imagen destacada, pasa el cursor sobre la imagen
              deseada y haz clic en el ícono
              <a class="bg-yellow text-white p-1">
                <i class="fas fa-star"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div id="exteriores" class="w-100">
          <div class="row">
            <div
              class="col-4 col-md-3 position-relative col-caract text-center mt-2 mt-lg-1"
              [class]="characteristic.other ? 'container-hover' : ''"
              *ngFor="
                let characteristic of characteristics['exterior'];
                index as j
              "
            >
              <input
                type="checkbox"
                name="{{ characteristic.slug }}"
                id="{{ characteristic.slug }}"
                class="check-cat"
                *ngIf="characteristic.config.type == 'simple'"
                [(ngModel)]="characteristics['exterior'][j].config.value"
              />
              <label
                for="{{ characteristic.slug }}"
                class="mx-auto mb-0"
                *ngIf="characteristic.config.type == 'simple'"
              >
                <img
                  src="{{ characteristic.image }}"
                  alt=""
                  width="70px"
                  class="mx-auto aspect-ratio-1 object-fit-contain"
                />
              </label>

              <div
                class="img-cat"
                *ngIf="characteristic.config.type != 'simple'"
              >
                <a
                  href="#{{ characteristic.slug }}"
                  data-toggle="collapse"
                  class="d-block mx-auto"
                  (click)="collapseItems(characteristic.slug)"
                >
                  <img
                    src="{{ characteristic.image }}"
                    alt=""
                    width="70px"
                    class="mx-auto aspect-ratio-1 object-fit-contain"
                  />
                </a>
              </div>
              <hr class="hr-black" />
              <label
                for="{{ characteristic.slug }}"
                class="d-block text-color-black text-regular mx-auto p-90 lh-1"
                *ngIf="characteristic.config.type == 'simple'"
              >
                <span class="text-center">{{ characteristic.name }}</span>
              </label>
              <a
                href="#{{ characteristic.slug }}"
                data-toggle="collapse"
                class="d-block text-color-black text-regular mx-auto p-90 lh-1"
                *ngIf="characteristic.config.type != 'simple'"
                (click)="collapseItems(characteristic.slug)"
              >
                <span class="text-center">{{ characteristic.name }} </span>
                <i class="mt-1 fas fa-chevron-down"></i>
              </a>

              <div
                class="collapse sub-cat"
                id="{{ characteristic.slug }}"
                *ngIf="characteristic.config.type != 'simple'"
              >
                <div class="d-flex px-4 mt-3">
                  <p class="text-regular text-gray float-left">
                    {{ characteristic.config.display_name }}
                  </p>
                  <i
                    (click)="removeClass(characteristic.slug, 'show')"
                    class="fas fa-times fa-lg float-right text-right text-yellow mt-1 ml-auto"
                  ></i>
                </div>

                <div
                  class="row text-center px-4"
                  *ngIf="characteristic.config.type == 'counter'"
                >
                  <div
                    class="col-2 px-2"
                    *ngFor="let i of ['1', '2', '3', '4', '5', '5+']"
                  >
                    <input
                      type="radio"
                      name="{{ characteristic.config.identifier }}"
                      id="{{ (i == '5+' ? '5more' : i) + characteristic.slug }}"
                      [value]="i"
                      [(ngModel)]="characteristics['exterior'][j].config.value"
                      class="radio-yellow"
                    />
                    <label
                      for="{{
                        (i == '5+' ? '5more' : i) + characteristic.slug
                      }}"
                      *ngIf="characteristics['exterior'][j].config.value != i"
                      >{{ i }}</label
                    >
                    <label
                      for="{{
                        (i == '5+' ? '5more' : i) + characteristic.slug
                      }}"
                      (click)="
                        characteristics['exterior'][j].config.value = null
                      "
                      *ngIf="characteristics['exterior'][j].config.value == i"
                      >{{ i }}</label
                    >
                  </div>
                </div>

                <div *ngIf="characteristic.config.type == 'multiple-list'">
                  <div
                    class="row mt-0 px-3"
                    *ngFor="let item of characteristic.config.items; index as z"
                  >
                    <div class="col px-4">
                      <p class="mb-0 float-left text-regular">
                        {{ item.name }}
                      </p>
                      <div class="float-right">
                        <input
                          type="checkbox"
                          name="{{ item.value }}"
                          id="{{ item.value }}"
                          [value]="item.value"
                          [(ngModel)]="
                            characteristics['exterior'][j].config.items[z]
                              .content
                          "
                          class="check-yellow no-close"
                        />
                        <label for="{{ item.value }}" class="no-close mb-0">
                          <i class="fas fa-check fa-lg no-close"></i>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="middle-hover otros pointer"
                *ngIf="characteristic.other"
              >
                <div
                  class="text-hover"
                  (click)="characteristics[1].splice(j, 1)"
                >
                  <i class="fas fa-trash"></i>
                </div>
              </div>
            </div>

            <div
              class="col-md-3 col-4 position-relative text-center mt-2 mt-lg-1"
            >
              <div
                class="img-cat"
                (click)="chselected.ch = { index: 'exterior' }"
              >
                <a
                  href="#other-exteriores"
                  data-toggle="collapse"
                  class="d-block mx-auto"
                  id="addAnotherChar-exteriores"
                >
                  <img
                    src="./assets/img/otros.png"
                    width="70px"
                    class="mx-auto aspect-ratio-1 object-fit-contain"
                  />
                </a>
              </div>
              <hr class="hr-black" />
              <a
                href="#other-exteriores"
                data-toggle="collapse"
                class="d-block text-color-black text-regular mx-auto p-90 cursor-pointer"
                (click)="chselected.ch = { index: 'exterior' }"
              >
                <span class="text-center">¿Otro? </span>
                <i class="mt-1 fas fa-chevron-down"></i>
              </a>

              <div
                class="collapse sub-cat container-fluid other-items-char no-close"
                id="other-exteriores"
              >
                <div class="d-flex px-2 mt-3 no-close">
                  <p class="text-regular text-gray float-left mr-4 no-close">
                    Agregar característica Interiores
                  </p>
                  <a
                    href="javascript:void(0)"
                    class="float-right text-right no-close"
                    id="close-char-exteriores"
                    (click)="resetAddCharacteristic()"
                  >
                    <i
                      class="fas fa-times fa-lg text-yellow mt-1 ml-auto no-close"
                    ></i>
                  </a>
                </div>

                <div class="row no-close">
                  <div class="col px-4 no-close">
                    <div class="form-group no-close mb-0">
                      <label
                        for="other-exteriores-name"
                        style="left: 15% !important"
                        class="no-close"
                      >
                        <p class="text-thin no-close">Nombre característica</p>
                      </label>
                      <input
                        type="email"
                        class="px-4 ml-2 mb-3 w-100 no-close"
                        name="other-exteriores-name"
                        id="other-exteriores-name"
                        [(ngModel)]="chselected.name"
                      />
                    </div>
                  </div>
                </div>
                <div class="row text-center px-4 no-close">
                  <div
                    class="col col-md-2 px-2 no-close"
                    *ngFor="let i of ['1', '2', '3', '4', '5', '5+']"
                  >
                    <input
                      type="radio"
                      name="{{
                        i == '5+' ? '5more' : i
                      }}-other-counter-exterior"
                      id="{{ i == '5+' ? '5more' : i }}-other-counter-exterior"
                      [value]="i"
                      [(ngModel)]="chselected.value"
                      class="radio-yellow no-close"
                    />
                    <label
                      for="{{ i == '5+' ? '5more' : i }}-other-counter-exterior"
                      class="no-close"
                      >{{ i }}</label
                    >
                  </div>
                </div>
                <button
                  type="button"
                  class="btn-yellow my-2 px-5 py-2"
                  [disabled]="chselected.value == '' || chselected.name == ''"
                  (click)="addCharacteristic()"
                >
                  <h5 class="text-mediumm-0 mb-0">Guardar</h5>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- <section class="container py-2 border-bottom">
    <h4 class="text-red text-center font-weight-bold">Planos del proyecto</h4>
    <div class="row">
      <div class="col-12">
        <div class="photo">
          <div class="row mb-2">
            <div class="col-md-12 pt-3" *ngIf="croppedImages?.length > 0">
              <div class="row mx-0">
                <ng-container *ngFor="let cp of croppedImages; index as i">
                  <div class="col-12 mb-2" *ngIf="cp.data == 'planes_files'">
                    <div class="photo w-100 container-hover">
                      <div class="container">
                        <div class="row align-items-center">
                          <div class="col-md-6">
                            <img
                              src="{{
                                cp.type == 'image'
                                  ? cp.cropped
                                  : getMimeVideo(cp)
                              }}"
                              class="img-selected image-hover mt-1"
                              style="min-height: 154px; max-height: 100px"
                            />
                            <span
                              *ngIf="i == 0"
                              style="
                                position: absolute;
                                top: 0;
                                background: #ffffffcc;
                                line-height: 1;
                                font-weight: 700;
                                font-size: 0.75em;
                                right: 0;
                                left: 0;
                                text-align: center;
                                padding: 0.25em 0;
                              "
                              class="mt-1"
                              >Esta es tu imagen destacada</span
                            >
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <p>Área construida</p>
                              <input
                                type="number"
                                id="area_construida"
                                name="area_construida"
                                [(ngModel)]="cp.area_construida"
                              />
                            </div>
                            <div class="form-group">
                              <p>Área A.A.:</p>
                              <input
                                type="number"
                                id="area_aa"
                                name="area_aa"
                                [(ngModel)]="cp.area_aa"
                              />
                            </div>
                            <div class="form-group">
                              <p>Área Privada:</p>
                              <input
                                type="number"
                                id="area_privada"
                                name="area_privada"
                                [(ngModel)]="cp.area_privada"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mx-0 mt-2 justify-content-center">
                        <div
                          data-toggle="modal"
                          data-target="#imagesModal"
                          data-backdrop="static"
                          data-keyboard="false"
                          class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                          *ngIf="cp.event && cp.type == 'image'"
                          (click)="editCroppedImage(cp, i)"
                        >
                          <a
                            class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                          >
                            <i class="fas fa-edit"></i>
                          </a>
                        </div>
                        <div
                          class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                          *ngIf="!edit"
                          (click)="croppedImages.splice(i, 1)"
                        >
                          <a
                            class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                          >
                            <i class="fas fa-trash"></i>
                          </a>
                        </div>
                        <div
                          class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                          *ngIf="!edit && i != 0"
                          (click)="changePosition(i)"
                        >
                          <a
                            class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                          >
                            <i class="fas fa-star"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="row justify-content-center col-lg-12">
              <div class="col-lg-auto">
                <label
                  for="planes_files"
                  class="d-block btn-yellow p-sm-90 text-center mx-auto p-2 mt-2 mb-0 cursor-pointer"
                  style="width: 150px"
                  >Subir foto</label
                >
                <input
                  type="file"
                  accept="image/*"
                  style="display: none"
                  multiple
                  id="planes_files"
                  (change)="fileChangeEvent($event, 'planes_files')"
                />
              </div>
            </div>
            <span class="col-12 text-center mt-1 text-info"
              >Para cambiar tu imagen destacada, pasa el cursor sobre la imagen
              deseada y haz clic en el ícono
              <a class="bg-yellow text-white p-1">
                <i class="fas fa-star"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </section> -->


  <section class="container py-2 border-bottom">
    <h4 class="text-red text-center font-weight-bold">Ventajas de la zona</h4>
    <div class="row mt-2 mt-lg-0">
      <div class="col-6 col-md-2 mt-1" *ngFor="let site of sites; index as i">
        <input
          type="checkbox"
          id="{{ site.slug }}"
          name="{{ site.slug }}"
          [(ngModel)]="sites[i].value"
        />
        <label
          for="{{ site.slug }}"
          class="sitios mb-1"
          (click)="removeNearbySite(site, i)"
          *ngIf="sites[i].deleted_at == null"
        >
          <i class="fas fa-check check-sitios"></i>
          <p class="text-regular text-gray mb-0 font-70">
            <img
              [src]="'./assets/img/constructoras/commons/' + advantagesImages[site.slug] + '.svg'"
              width="16"
              height="16"
            />
            {{ site.name }}
          </p>
        </label>
        <span
          class="text-danger"
          *ngIf="site.type == 'other' && site.deleted_at != null"
        >
          El sitio <b>{{ site.name }}</b> se eliminará
          <a
            class="cursor-pointer"
            (click)="sites[i].deleted_at = null; sites[i].value = true"
            >Cancelar</a
          >
        </span>
      </div>
      <div class="col-6 col-md-2 mt-1">
        <input
          type="checkbox"
          id="other-nearby-sites"
          name="other-nearby-sites"
        />
        <label
          onclick="$('#dropdown-other-nearby-sites').click()"
          class="sitios pointer mb-1"
        >
          <i class="fas fa-check check-sitios"></i>
          <p class="text-regular text-gray mb-0 font-70 justify-content-between d-flex">
            Otro sitio cercano
            <img
              src="https://cdn.vivienda.com/images/icons/more-icon.png"
              class="mt-0"
              style="width: 1rem"
            />
          </p>
        </label>
        <a
          id="dropdown-other-nearby-sites"
          data-toggle="collapse"
          href="#collapseOtherNearbySites"
          role="button"
          aria-expanded="false"
          aria-controls="collapseOtherNearbySites"
        ></a>
        <div
          class="collapse w-100 sub-cat container-fluid other-items-char no-close px-2 pb-1"
          id="collapseOtherNearbySites"
        >
          <div class="w-100 text-right pt-2 lh-1">
            <a
              class="text-yellow ml-auto pointer"
              onclick="$('#collapseOtherNearbySites').removeClass('show')"
              ><i class="fas fa-times"></i
            ></a>
          </div>
          <label for="other_sites" class="m-0 no-close small">
            <span class="text-regular no-close">Escribe el sitio</span>
          </label>
          <div class="form-group mb-1 no-close" id="other_sites_container">
            <input
              type="text"
              name="other"
              id="other_sites"
              class="w-100 px-4 no-close mt-0"
              data-role="tagsinput"
              [(ngModel)]="nearby_site"
            />
            <button
              type="button"
              class="btn-yellow my-2 px-5 py-2"
              (click)="addNearbySite()"
            >
              Agregar
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="container mt-3">
    <div class="text-center text-lg-right">
      <button
        type="submit"
        class="btn btn-red btn-rounded font-italic small px-4"
      >
        PUBLICAR
      </button>
    </div>
  </section>
</form>
